import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../store/hooks';
import { dismissToast } from '../../../../store/slices/uiSlice';
import { ToastItem } from './ToastItem';
import { tokens } from '../../../../theme/tokens';

export const ToastContainer: React.FC = () => {
  const toasts = useAppSelector((state) => state.ui.toasts);
  const dispatch = useAppDispatch();

  const handleDismiss = (id: string) => {
    dispatch(dismissToast(id));
  };

  // Only show the last 3 toasts
  const visibleToasts = toasts.slice(-3);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: tokens.zIndex.toast,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        maxHeight: '100vh',
        overflow: 'hidden',
        pointerEvents: 'none',
        '& > *': {
          pointerEvents: 'auto',
        },
      }}
    >
      {visibleToasts.map((toast) => (
        <ToastItem key={toast.id} {...toast} onDismiss={handleDismiss} />
      ))}
    </Box>
  );
};
